import { Trash } from 'phosphor-react'
import { useParams } from 'react-router-dom'

import { useAuth } from '@/hooks/useAuth'

import styles from './styles.module.scss'

import { URLs } from '@/config/env'
import { ViewType } from '../student.admin'
import { AlunoRepository } from '@/pages/admin/repositories/aluno.repository'
import { Document } from '@/domain/entities/document.entity'

interface IProps {
  setView: React.Dispatch<React.SetStateAction<ViewType>>
  documents: Document[]
  listDocuments: () => void
  setLoading: React.Dispatch<React.SetStateAction<Boolean>>
}

export const AddDocument = ({
  setView,
  documents,
  listDocuments,
  setLoading,
}: IProps) => {
  const { token } = useAuth()
  const { id } = useParams()

  const openFile = async (filename: string) => {
    const safeFilename = encodeURIComponent(filename)
    window.open(
      `${URLs.FRONT_URL}/aluno/${id}/document/${filename}`,
      '_blank',
      'noopener,noreferrer',
    )
  }

  async function deleteDocument(document_id: string) {
    setLoading(true)
    await AlunoRepository.GetInstance().adminDeleteDocumento(token, document_id)
    listDocuments()
    setLoading(false)
  }

  return (
    <div className={styles.container}>
      {documents?.map((doc) => {
        return (
          <div className={styles.content} key={doc.id}>
            <button
              className={styles.button_link}
              onClick={() => openFile(doc.filename)}
            >
              {doc?.filename}
            </button>
            <Trash
              className={styles.delete_button}
              onClick={() => deleteDocument(doc.id.toString())}
              size={20}
            />
          </div>
        )
      })}

      <button onClick={() => setView('ADD DOCUMENT')}>
        Adicionar Documento
      </button>
    </div>
  )
}
